<div class="text-bold kiosk-xl:py-40 px-10 text-center text-xl">
  @if (isLoading) {
    <div class="flex items-center justify-center py-6">
      <i class="icon icon-privacy animate-pulse text-4xl"></i>
    </div>
  }

  @if (!isLoading) {
    <div class="kiosk-xl:text-6xl flex items-center justify-center py-6 text-3xl font-bold">
      {{ terminalInstructionMessage() | translate }}
    </div>
  }

  @if (statusMessage) {
    <div>{{ statusMessage }}</div>
  }

  @if (errorMessage) {
    <div class="mt-6 text-center text-base text-error-800">
      {{ errorMessage }}
    </div>
  }

  @if (isOnError) {
    <div class="mt-6 flex flex-row justify-center">
      <app-button-atom
        size="M"
        label="Réessayer"
        (click)="createOrder()"
        type="primary"
      ></app-button-atom>
    </div>
    <div class="mt-4 flex flex-row justify-center">
      <app-button-atom
        size="XS"
        thickSize="S"
        label="Retourner au panier"
        (click)="backToCart()"
        type="light"
      ></app-button-atom>
    </div>
  }
</div>

@if (loadKioskResetTimer) {
  <app-kiosk-cart-reset-timer-block
    [config]="{ 'wait_for_user_interaction_to_display_modal': false }"
  ></app-kiosk-cart-reset-timer-block>
}
